<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="products"
    :items-per-page="10"
    :disable-sort="$vuetify.breakpoint.smAndDown"
    :footer-props="{'items-per-page-text': 'Số nhóm mỗi trang'}"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Hệ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} hệ
    </template>
    <template v-slot:[`item.note`]="{item}">
      {{ item | getDesc }}
    </template>
    <template v-slot:[`item.name`]="{item}">
      <a :href="`/admin/product/${item.id}`" class="clickable-text">
        {{ item.name }}
      </a>
    </template>
    <template v-slot:[`item.grade`]="{item}"> Khối {{ item.grade }} </template>
    <template v-slot:[`item.status`]="{item}">
      {{ item | getStatus }}
    </template>
  </v-data-table>
</template>

<script>
const originHeaders = [
  {
    text: 'Tên hệ đào tạo',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Tên viết tắt',
    value: 'acronym',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Khối tuyển sinh',
    value: 'grade',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  },

  {
    text: 'Phân loại',
    value: 'productType.name',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Ghi chú',
    value: 'note',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  }
]

import {get} from 'lodash'

export default {
  props: {
    products: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },
  created() {
    this.loading = true
  },
  watch: {
    products(newVal) {
      if (newVal) {
        this.loading = false
      }
    }
  },
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'active') {
        return 'Đang hoạt động'
      } else if (item.status === 'inActive') {
        return 'Đã bị khóa'
      } else if (item.status === 'removed') {
        return 'Đã bị xóa'
      } else {
        return ''
      }
    }
  }
}
</script>
